<template>
  <div v-if="priceRange" class="space-y-3">
    <h4 class="font-medium">Fiyat Aralığı</h4>
    <div class="grid grid-cols-2 gap-2">
      <UInput
        v-model="localMin"
        type="number"
        placeholder="Min"
        size="sm"
        @change="emitUpdate"
      />
      <UInput
        v-model="localMax"
        type="number"
        placeholder="Max"
        size="sm"
        @change="emitUpdate"
      />
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  priceRange: {
    type: Object,
    default: null
  },
  selectedMin: {
    type: Number,
    default: null
  },
  selectedMax: {
    type: Number,
    default: null
  }
})

const emit = defineEmits(['update'])

const localMin = ref(props.selectedMin || '')
const localMax = ref(props.selectedMax || '')

const emitUpdate = () => {
  emit('update', {
    min: localMin.value || null,
    max: localMax.value || null
  })
}

watch(
  () => [props.selectedMin, props.selectedMax],
  ([newMin, newMax]) => {
    localMin.value = newMin || ''
    localMax.value = newMax || ''
  }
)
</script>
